export default {
  polls: [],
  pagination: {},
  poll: {}
}
